import { debug, observer, React, theme, ui, styled } from "aaa";
import { Step, StepButton, StepLabel, Stepper } from "material-ui/Stepper";

type IProps = {
    step: number;
    highestStep: number;
    history: any;
};


export const NAVBAR_STEPS = ["/base", "/contact", "/income", "/expenses", "/documents", "/summary"];

const Description = styled.div`
    @media (max-width: 749px) {
        display: none;
    }
`;

@observer
export class NavigationBar extends React.Component<IProps, {}> {

    renderStep = (description: string, stepIndex: number) => {
        const HEIGHT = 44;
        const label = (
            <StepLabel style={{ height: HEIGHT }}>
                <Description>
                    {description}
                </Description>
            </StepLabel>
        );

        // Don't use highest step logic -> this would skip form submission
        // when the user changes stuff
        // if (this.props.highestStep >= stepIndex) {
        if (this.props.step >= stepIndex) {
            return (
                <Step disabled={false}>
                    <StepButton style={{ height: HEIGHT }} onClick={() => this.props.history.push(NAVBAR_STEPS[stepIndex])}>
                        {label}
                    </StepButton>
                </Step>
            );
        } else {
            return (
                <Step>{label}</Step>
            );
        }
    }

    render() {
        return (
            <div style={{ paddingLeft: theme.MARGIN, paddingRight: theme.MARGIN, marginTop: 30 /*ui.isMobile ? 30 : 60*/, marginBottom: -theme.MARGIN }}>
                <Stepper linear activeStep={this.props.step}>
                    {this.renderStep(ui.__("stepper.baseData"), 0)}
                    {this.renderStep(ui.__("stepper.contactInformation"), 1)}
                    {this.renderStep(ui.__("stepper.income"), 2)}
                    {this.renderStep(ui.__("stepper.expenses"), 3)}
                    {this.renderStep(ui.__("stepper.documents"), 4)}
                    {this.renderStep(ui.__("stepper.summary"), 4)}
                </Stepper>
            </div>
        );
    }
}





// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/NavigationBar.tsx